import { C4ListResponse } from '@domain/interface/c4-list-response';
import { createAction, props } from '@ngrx/store';
import { Owner } from 'cargo-chief-commons';

export const LOADS = {
	LOADS_LIST: {
		GET: createAction('[LOADS_LIST] Get Loads list', props<any>()),
		SUCCESS: createAction('[LOADS_LIST] Get loads list success', props<C4ListResponse<any>>()),
		FAILURE: createAction(
			'[LOADS_LIST] Get loads list failed',
			props<{ payload: { message: string } }>()
		),
	},
	QUOTES_LIST: {
		GET: createAction('[LOADS_LIST] Get Quotes list', props<any>()),
		SUCCESS: createAction('[LOADS_LIST] Get Quotes list success', props<C4ListResponse<any>>()),
		FAILURE: createAction(
			'[LOADS_LIST] Get Quotes list failed',
			props<{ payload: { message: string } }>()
		),
	},

	CANCEL_LOADS: {
		GET: createAction('[LOADS_LIST] cancel loads list', props<any>()),
		SUCCESS: createAction('[LOADS_LIST] cancel loads list success', props<C4ListResponse<any>>()),
		FAILURE: createAction(
			'[LOADS_LIST] cancel loads list failed',
			props<{ payload: { message: string } }>()
		),
	},

	WINNING_BID_CARRIER: {
		GET: createAction('[LOADS_LIST] Get carriers list', props<any>()),
		SUCCESS: createAction('[LOADS_LIST] Get carriers list success', props<C4ListResponse<any>>()),
		FAILURE: createAction(
			'[LOADS_LIST] Get carriers list failed',
			props<{ payload: { message: string } }>()
		),
	},

	ACTIONS: {
		BOOKED_LOADS: {
			ASSIGN_CUSTOMER: {
				OPEN_DIALOG: createAction(
					'[LOADS_LIST] Open historical load assign customer dialog',
					props<any>()
				),
				FAILURE: createAction(
					'[LOADS_LIST] Failed to assign customer to historical load',
					props<any>()
				),
				CLOSE: createAction(
					'[LOADS_LIST] Close historical load assign customer dialog',
					props<any>()
				),
			},
			ASSIGN_CARRIER: {
				OPEN_DIALOG: createAction(
					'[LOADS_LIST] Open historical load assign carrier dialog',
					props<any>()
				),
				FAILURE: createAction(
					'[LOADS_LIST] Failed to assign carrier to historical load',
					props<any>()
				),
				CLOSE: createAction(
					'[LOADS_LIST] Close historical load assign carrier dialog',
					props<any>()
				),
			},
			SUCCESS: createAction(
				'[LOADS_LIST] historical load updated successfully for carrier, customer',
				props<any>()
			),
		},
		ACTIVE_LOADS: {
			CANCEL_LOADS: {
				CANCEL: createAction('[LOADS_LIST] cancel selected loads', props<any>()),
				OPEN_DIALOG: createAction(
					'[LOADS_LIST] Open cancel loads confirmation dialog',
					props<any>()
				),
				SUCCESS: createAction('[LOADS_LIST] cancelled loads successfully', props<any>()),
				FAILURE: createAction('[LOADS_LIST] Failed to cancel loads', props<any>()),
				CLOSE: createAction('[LOADS_LIST] Close cancel loads confirmation dialog', props<any>()),
			},
		},
		POST_LOAD: {
			OPEN_DIALOG: createAction('[LOADS_LIST] Open post load dialog', props<any>()),
			FAILURE: createAction('[LOADS_LIST] post load failed', props<any>()),
			CLOSE: createAction('[LOADS_LIST] Close post load dialog', props<any>()),
		},
	},

	USERS_LIST: {
		SET: createAction('[LOADS_LIST] Set Users List', props<{ usersList: Owner[] }>()),
	},
	SORT: {
		SET: createAction('[LOADS_LIST] Loads list Set sort', props<{ sort: any[] }>()),
	},
	FILTERS: {
		SET: createAction('[LOADS_LIST] Loads list Set filters', props<{ filters: any[] }>()),
	},

	ACTIVE_TAB: {
		SET: createAction('[LOADS_LIST] Loads list Set ACTIVE_TAB', props<{ activeTab: string }>()),
	},
	CUSTOM_TAB: {
		GET: createAction('[LOADS_LIST] Get Custom Tab', props<any>()),
		DELETE: createAction('[LOADS_LIST] Delete Custom Tab', props<any>()),
		DELETE_SUCCESS: createAction('[LOADS_LIST] Delete Custom Tab Success', props<any>()),
		SUCCESS: createAction('[LOADS_LIST] Get Custom Tab Success', props<any>()),
		FAILURE: createAction(
			'[LOADS_LIST]Get Custom Tab Failure',
			props<{ payload: { message: string } }>()
		),
	},
	TABS: {
		SET: createAction('[LOADS_LIST] Set Loads tabs', props<{ allTabs: string[] }>()),
	},
	CUSTOM_TAB_BOOKED: {
		SET: createAction(
			'[LOADS_LIST] Set is booked true for custom tab tabs',
			props<{ isCustomTabBooked: boolean }>()
		),
	},
	USERS_SORT_AND_FILTERS: {
		GET: createAction('[LOADS_LIST] get saved users sorts and filters', props<any>()),
		SUCCESS: createAction('[LOADS_LIST] get saved users sorts and filters success', props<any>()),
		FAILURE: createAction('[LOADS_LIST] get saved users sorts and filters failure', props<any>()),
		SET: createAction('[LOADS_LIST] Set saved custom tabs and filters', props<any>()),
	},

	UPDATE_LOAD: {
		SET: createAction('[LOADS_LIST] update load details', props<any>()),
	},
	LOADS_TABLE: {
		SET: createAction('[LOADS_LIST] set load table data', props<any>()),
	},
	BOOKED_LOADS: {
		SET: createAction('[LOADS_LIST] Set is booked loads tabs', props<{ isBookedTab: boolean }>()),
	},

	SET: {
		ACTIVE_TAB: createAction('[LOADS_LIST] Set is active tabs', props<{ isActiveTab: boolean }>()),
		CUSTOM_ACTIVE_TAB: createAction(
			'[LOADS_LIST] Set is custom tab active',
			props<{ isCustomTabActive: boolean }>()
		),
		OPEN_TAB: createAction('[LOADS_LIST] Set is open tabs', props<{ isOpenTab: boolean }>()),
		CUSTOM_OPEN_TAB: createAction(
			'[LOADS_LIST] Set is custom tab open',
			props<{ isCustomTabOpen: boolean }>()
		),
	},
};
